import { IApplicationState } from '../../types/redux';

export function getIsRequestCallbackOpen(state: IApplicationState) {
  return state.requestCallback.isPopupOpen;
}
